import React from 'react';
import {Button, Typography} from '@mui/material';
import styles from './style.module.scss';
import {t} from 'i18next';

type AskLioFeedbackPromptProps = {
  onClick?: () => void;
};

const AurAskLioFeedbackPrompt: React.FC<AskLioFeedbackPromptProps> = ({
  onClick,
}) => {
  return (
    <>
      <Typography
        aria-label={t('askLio.feedback.rateQuestionText')}
        className={`${styles.aurBoxFeedbackTypography}`}
      >
        {t('askLio.feedback.rateQuestionText')}
        <Button
          aria-label={t('askLio.feedback.rateButtonText')}
          tabIndex={0}
          className={`${styles.aurBoxFeedbackTypographyButton}`}
          onClick={onClick}
        >
          {t('askLio.feedback.rateButtonText')}
        </Button>
      </Typography>
    </>
  );
};

export default AurAskLioFeedbackPrompt;
